import styled from "styled-components/macro";
import { media } from "../../../utils";

export const ErrorIcon = styled.svg(({ theme }) => ({
  marginRight: "12px",
  fontSize: "2rem",
  color: theme.color.feedback.error,
}));

export const TitleModal = styled.span({
  marginBottom: 0,
});

export const ErrorHeader = styled.div({
  display: "flex",
  alignItems: "center",
  padding: "20px 0",
});

export const CustomModal = styled.div({
  [media.lg()]: {
    maxWidth: "556px",
  },
});
